// extracted by mini-css-extract-plugin
export var createdDate = "_jo-1";
export var divider = "_jo-2";
export var headerDivider = "_jo-3";
export var messagesCard = "_jo-0";
export var messagesContainer = "_jo-6";
export var messagesContainerWrapper = "_jo-4";
export var showLeftPanelButton = "_jo-8";
export var topButtons = "_jo-7";
export var withPadding = "_jo-5";